import { useEffect } from 'react'
import { ProjectWrapper, LinkButton } from '../../GlobalStyles'
import { ViewAllProjects } from '../../components/ViewAllProjects'
import { ImageLoader } from '../../components/ImageLoader'
import wave from '../../assets/white-wave.svg'
import mockups from '../../assets/sushi-heaven/sushi-heaven-mockups.png'

export const SushiHeaven = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <ProjectWrapper>
      <div
        className='banner'
        style={{ background: 'linear-gradient(to right, #FFECB3, #FFB3D2)' }}
      >
        <img src={wave} alt='decorative wave' />
      </div>

      <section className='description'>
        <h1 className='title'>[ <b>Sushi Heaven</b> ]</h1>
        <div className='summary'>
          <p className='type'>Frontend Development, JavaScript Game</p>
          <p className='duration'>Solo Project • Mar 2021</p>
        </div>

        <div className='details'>
          <p>
            Sushi Heaven is an idle-clicker game built in vanilla JavaScript. Players produce sushi  
            to earn currency, purchase upgrades, and expand to a multi-location franchise.  
            Progressive difficulty and visual feedback keep users engaged.
          </p>

          <div className='mockups'>
            <ImageLoader src={mockups} alt='Sushi Heaven mockups' borderRadius='10px' />
          </div>

          <p>
            Game state persists via localStorage, allowing seamless continuation across sessions.  
            Modular code architecture and animation logic optimize performance and maintainability.
          </p>

          <div className='buttons'>
            <LinkButton
              className='black'
              href='https://sushi-heaven.netlify.app/'
              target='_blank'
              rel='noopener noreferrer'
            >
              Play Game
            </LinkButton>
          </div>
        </div>
      </section>
      <ViewAllProjects />
    </ProjectWrapper>
  )
}
